import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let patient = useDataValue({
    context: 'patient',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (patient.booking) {
      return [{ ...patient.booking.appointment.tx.organization }]
    }

    let uniqueLocations = new Set()
    return patient.tx_cards
      .flatMap(tx_card => tx_card.txs)
      .map(tx => tx.organization)
      .filter(Boolean)
      .filter(location => {
        if (uniqueLocations.has(location._id)) return false
        uniqueLocations.add(location._id)
        return true
      })
  }, [patient])
}
